import axios from "axios";
import {
  BACKEND_SERVER_URL,
  industryUserTokenName,
  internalUserTokenName,
  merchantTokenName,
  studentTokenName,
  superAdminTokenName,
} from "./config";
import validatorPackage from "validator";


// Use backend port from your .env
export const server = axios.create({
  // baseURL: "https://amcbackend.amcfest.in/api/",
  baseURL: "https://amcbackend.amcfest.in/api", // ✅ match backend port
  withCredentials: true, // Important for cookies
});

// ----------------- Token Helpers -----------------

export const getStudentTokenFromLocal = () => {
  return sessionStorage.getItem(studentTokenName);
};

export const removeStudentTokenFromLocal = () => {
  return sessionStorage.removeItem(studentTokenName);
};

export const getIndustryUserToken = () => {
  return sessionStorage.getItem(industryUserTokenName);
};

export const removeIndustryUserToken = () => {
  return sessionStorage.removeItem(industryUserTokenName);
};

export const getSuperAdminToken = () => {
  return sessionStorage.getItem(superAdminTokenName);
};

export const removeSuperAdminToken = () => {
  return sessionStorage.removeItem(superAdminTokenName);
};

export const getInternalUserToken = () => {
  return sessionStorage.getItem(internalUserTokenName);
};

export const removeInternalUserToken = () => {
  return sessionStorage.removeItem(internalUserTokenName);
};

export const getMerchantToken = () => {
  return sessionStorage.getItem(merchantTokenName);
};

export const removeMerchantToken = () => {
  return sessionStorage.removeItem(merchantTokenName);
};

// ----------------- Utilities -----------------

export const blobToFile = (data) => {
  return data ? window.URL.createObjectURL(data) : null;
};

export const validateIndianPhone = (phone) => {
  return validatorPackage.isMobilePhone(phone + "", "en-IN");
};

export const truncateText = (text, limit) => {
  const words = text.split(" ");
  if (words.length > limit) {
    return words.slice(0, limit).join(" ") + " ...";
  }
  return text;
};
